import { create } from "zustand";
import { persist } from "zustand/middleware";
import { createSessionStoragePersist } from "../utils/sessionStoragePersist";

export interface NatalChartDetails {
  moon_sign: string;
  ascendant_sign: string;
}

export interface NatalChart {
  id: number;
  profile_id: number;
  chart_svg_path: string;
  summary: string;
  details?: NatalChartDetails; // <-- Добавлено!
}

interface NatalChartState {
  natalChart: NatalChart | null;
  setNatalChart: (data: NatalChart) => void;
  clearNatalChart: () => void;
}

export const useNatalChartStore = create<NatalChartState>()(
  persist(
    (set) => ({
      natalChart: null,
      setNatalChart: (data) => set({ natalChart: data }),
      clearNatalChart: () => set({ natalChart: null }),
    }),
    createSessionStoragePersist<NatalChartState>(
      "natalChart",
      (state) => ({ natalChart: state.natalChart } as NatalChartState)
    )
  )
);
